import { ComponentsOverrides, Theme } from "@mui/material";

import borders from "@/themes/base/borders";
import colors from "@/themes/base/colors";
import typography from "@/themes/base/typography";
import pxToRem from "@/themes/functions/pxToRem";

const { light, text, dark } = colors;
const { borderRadius } = borders;
const { size } = typography;

interface IMenuItem {
  styleOverrides: ComponentsOverrides<Theme>["MuiMenuItem"];
}

const menuItem: IMenuItem = {
  styleOverrides: {
    root: {
      minWidth: pxToRem(160),
      minHeight: "unset",
      padding: `${pxToRem(4.8)} ${pxToRem(16)}`,
      borderRadius: borderRadius.md,
      fontSize: size.sm,
      color: text!.main,
      transition: "background-color 300ms ease, color 300ms ease",

      "&:hover, &:focus, &.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": {
        backgroundColor: light.main,
        color: dark.main,
      },
    },
  },
};

export default menuItem;
